module.exports = __webpack_public_path__ + "static/img/8.e68c5df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_icon/8.png
// module id = OH8w
// module chunks = 97